import { alereAxios } from '../utils/api';

export const getRevenueSummary = () => alereAxios.get('sales/revenue-summary');
